var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36919 9.87342L14.0178 16.5033L24.6665 9.87342L14.0178 3.24356L3.36919 9.87342ZM27.3287 9.87342V23.1332C27.3287 23.8365 27.0482 24.511 26.5489 25.0084C26.0497 25.5057 25.3725 25.7851 24.6665 25.7851H3.36919C2.66314 25.7851 1.98601 25.5057 1.48676 25.0084C0.987508 24.511 0.707031 23.8365 0.707031 23.1332V9.87342C0.707031 8.90546 1.22615 8.0701 1.99818 7.60601L14.0178 0.114258L26.0375 7.60601C26.8095 8.0701 27.3287 8.90546 27.3287 9.87342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.89aa3be04c3bea502e4ae3faafa456e4.svg";
export { ForwardRef as ReactComponent };